import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M12.4382 2.29639C12.2482 1.95101 11.7519 1.95101 11.5619 2.29639L1.40757 20.7589C1.2243 21.0921 1.46538 21.4998 1.84568 21.4998H22.1544C22.5347 21.4998 22.7758 21.0921 22.5925 20.7589L12.4382 2.29639ZM6.80559 14.64L9.97726 17.9242L10.6247 18.5946L11.1411 17.8188L15.7906 10.8341L14.542 10.0029L10.4088 16.2118L7.88458 13.598L6.80559 14.64Z",
  fill: "currentColor"
}, null, -1 /* HOISTED */)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }